/**
 * 
 */

function loadGeojsonvtLayer(layer){
	var objLayer = {activa: false, layer: null};
	var options = jQuery.parseJSON( layer.options );
	var canvasTiles = L.tileLayer.geoJSON(options);	

	canvasTiles.options.businessId = layer.businessId;
	canvasTiles.options.nom = layer.serverName;
	canvasTiles.options.tipus = layer.serverType;
	canvasTiles.options.url =  layer.url;

	if (null === layer.capesActiva || 'null' === layer.capesActiva || true === layer.capesActiva || "true" === layer.capesActiva){
		canvasTiles.addTo(map);
		objLayer.activa = true;
		var topPane = map.getPanes().mapPane.getElementsByClassName("leaflet-top-pane");
		if(topPane.length <= 0){
			topPane = L.DomUtil.create('div', 'leaflet-top-pane', map.getPanes().mapPane);
		}
		$("div.leaflet-top-pane").append(canvasTiles.getContainer());
		canvasTiles.setZIndex(4);
	}
			
	if (!layer.capesOrdre || layer.capesOrdre == null || layer.capesOrdre == 'null'){
		if(controlCapes) {
			canvasTiles.options.zIndex = controlCapes._lastZIndex + 1;
		}
	}else{
		canvasTiles.options.zIndex = parseInt(layer.capesOrdre);
	}		
	if(controlCapes) {
		controlCapes.addOverlay(canvasTiles, layer.serverName, true);
		controlCapes._lastZIndex++;	
	}
	objLayer.layer = canvasTiles;	
	return objLayer;			
}